module.exports = __webpack_public_path__ + "img/c04_unitstartechlaminararmor_Normal_ua.a2f55133.webp";